import { DateTime } from 'luxon';
import type { PublicWebinarSession } from '@/features/webinar/types';

/**
 * Un présentateur lance rarement à la seconde près : entre l'heure programmée et le clic
 * « Démarrer », la session reste à venir et les inscrits de dernière minute arrivent. On laisse
 * donc la page ouverte pendant ce délai, et on ne ferme que les sessions passées jamais lancées.
 */
export const SIGNIN_GRACE_AFTER_PLANNED_DATE_MS = 60 * 60 * 1000;

export function isPublicSigninClosed(
  session: PublicWebinarSession['session'] | null | undefined,
  now: number = Date.now(),
): boolean {
  if (!session) return false;

  if (session.status === 'FINISHED') return true;

  if (session.status === 'UPCOMING' && session.utcPlannedDate) {
    const plannedUtc = DateTime.fromISO(session.utcPlannedDate, { zone: 'utc' });
    if (!plannedUtc.isValid) return false;
    return now > plannedUtc.toMillis() + SIGNIN_GRACE_AFTER_PLANNED_DATE_MS;
  }

  return false;
}
